// Custom Compra mark for the Agent — a small "network" glyph (three nodes connected),
// used in place of generic sparkle iconography.
import { cn } from '@/lib/utils'

interface AgentMarkProps {
    size?: number
    className?: string
    strokeWidth?: number
}

function AgentMark({ size = 16, className, strokeWidth = 1.75 }: AgentMarkProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={cn('shrink-0', className)}
            aria-hidden='true'
        >
            {/* Connecting lines */}
            <path
                d='M10 4.5L4.5 14.5M10 4.5L15.5 14.5M4.5 14.5L15.5 14.5'
                stroke='currentColor'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
                opacity={0.55}
            />
            {/* Nodes */}
            <circle
                cx='10'
                cy='4.5'
                r='2'
                fill='currentColor'
                stroke='currentColor'
                strokeWidth={strokeWidth * 0.6}
            />
            <circle
                cx='4.5'
                cy='14.5'
                r='2'
                fill='currentColor'
                stroke='currentColor'
                strokeWidth={strokeWidth * 0.6}
            />
            <circle
                cx='15.5'
                cy='14.5'
                r='2'
                fill='currentColor'
                stroke='currentColor'
                strokeWidth={strokeWidth * 0.6}
            />
        </svg>
    )
}

export default AgentMark
export type { AgentMarkProps }
